import { render, staticRenderFns } from "./notificationexample.vue?vue&type=template&id=b4dfb9a6&scoped=true&"
import script from "./notificationexample.vue?vue&type=script&lang=js&"
export * from "./notificationexample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dfb9a6",
  null
  
)

export default component.exports